import { useEventCallback } from '@mui/material';
import { FakeDropdownBox } from '../../../filters';
import {
  IssueActionCountMultipleSelector,
  type TransformedIssueActionCountDto,
} from '../../../inputs';
import type { ExtendedGridColumnHeaderProps } from '../../types';
import { useDataGridContext } from '../../data-grid-context';
import { ContainerPopper } from './container-popper';

export function DataGridIssueActionCountFilter(
  params: ExtendedGridColumnHeaderProps,
) {
  const context = useDataGridContext();
  const value: TransformedIssueActionCountDto[] =
    context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox readOnly onClick={props.handleClick}>
          {value.length > 0
            ? value.map((issueSLA) => issueSLA.actionCount).join(', ')
            : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueActionCountMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
